import { render, staticRenderFns } from "./CategoryConnectedTypeList.vue?vue&type=template&id=9b88d1f6&scoped=true&"
import script from "./CategoryConnectedTypeList.vue?vue&type=script&lang=js&"
export * from "./CategoryConnectedTypeList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryConnectedTypeList.vue?vue&type=style&index=0&id=9b88d1f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b88d1f6",
  null
  
)

export default component.exports